export const MAX_CAROUSEL_THUMBNAILS_WIDTH = 880;
export const CAROUSEL_THUMBNAILS_NUMBER = 5;
export const MAX_CARD_THUMBNAIL_WIDTH = 1187;
export const CAROUSEL_CARDS_NUMBER = { mobile: 1, tablet: 4, desktop: 4 };
export const TITLE_FORMAT = '{year} {make} {model}';
export const TITLE_DATA = ['length'];
